import React from "react";
import "./styles.scss";
import { POSCalendar } from "../../assets/svgs";
import { getPaymentInfo, getPaymentLabel } from "../../utils";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

const PaymentScheduleCard = ({ payments = [], onSeeAll, heading, seeAll }) => {
  const location = useLocation();
  const { t } = useTranslation();
  const { pathname } = location;
  const routeName = pathname.split("/")[1];

  const isOverdue = (paymentDate) => {
    if (!paymentDate) return false;
    const today = new Date();
    // const simulatedToday = new Date("2026-01-01T00:00:00");
    const date = new Date(paymentDate);
    return date < today;
  };

  return (
    <div className="payment-schedule-card">
      <div className="header">
        <h3>{heading}</h3>
        <button className="see-all" onClick={onSeeAll}>
          {seeAll}
        </button>
      </div>

      <div className="payments-list">
        {payments &&
          payments.slice(0, 3).map((payment, index) => {
            const overdue = isOverdue(payment?.paymentDate);
            const paymentInfo = getPaymentInfo(payment?.paymentDate);

            return (
              <div
                key={index}
                className={`payment-item ${overdue ? "overdue" : ""}`}
              >
                <div className="date">
                  <span className="day">{paymentInfo?.day}</span>
                  <span className="month">{paymentInfo?.month}</span>
                </div>

                <div className="details">
                  <div className="title">{`${getPaymentLabel(payment?.no)} ${t(`${routeName}.payment`)}`}</div>
                  <div className="amount">
                    <span className="icon-saudi_riyal"></span>
                    {payment?.payment}
                  </div>
                </div>

                <div className="due">
                  <div className="due-icon">
                    <img
                      src={POSCalendar}
                      alt="calendar"
                      className="calendar-icon"
                    />
                  </div>
                  <span className="due-text">
                    {overdue ? "Overdue" : paymentInfo?.statusText || "On Time"}
                  </span>
                </div>
              </div>
            );
          })}
      </div>
    </div>
  );
};

export default PaymentScheduleCard;
